export const injection = {
	name: "Diversified Commercial Services",
	dateStart: "2020-09-21T12:00:00.000Z",
	dateEnd: "2020-09-24T22:00:00.000Z",
	days: [
		{
			id: 0,
			date: "2020-09-21T12:00:00.000Z",
			sessions: [
				{
					id: 0,
					name: "Regrant",
					dateStart: "2020-09-01T13:00:00.000Z",
					dateEnd: "2020-09-01T17:00:00.000Z",
					presentations: [
						{
							id: 0,
							name: "Betamethasone Dipropionate",
							dateStart: "2020-09-01T13:00:00.000Z",
							dateEnd: "2020-09-01T14:00:00.000Z",
							presenters: [
								"Sully Pittel",
								"Tiffanie Skough",
								"Freddy Schinetti"
							],
							credits: {
								Oceanic: "5"
							},
						},
						{
							id: 1,
							name: "Chlorpheniramine Maleate",
							dateStart: "2020-09-01T14:30:00.000Z",
							dateEnd: "2020-09-01T15:30:00.000Z",
							presenters: [
								"Etan Yeardley",
								"Engelbert Eede",
							],
							credits: {
								Fancy: "2"
							},
						}
					],
				},
				{
					id: 1,
					name: "Alphazap",
					dateStart: "2020-09-01T16:00:00.000Z",
					dateEnd: "2020-09-01T17:00:00.000Z",
					presentations: [
						{
							id: 2,
							name: "Choloepus hoffmani",
							dateStart: "2020-09-01T16:00:00.000Z",
							dateEnd: "2020-09-01T17:00:00.000Z",
							presenters: [
								"Aluino Dyde",
								"Essa Panter",
							],
							credits: {
								YSK: "3"
							}
						}
					],
				}
			]
		},
		{
			id: 1,
			date: "2020-09-22T12:00:00.000Z",
			sessions: [
				{
					id: 2,
					name: "Budgetary Management",
					dateStart: "2020-09-02T13:00:00.000Z",
					dateEnd: "2020-09-02T17:00:00.000Z",
					presentations: [
						{
							id: 3,
							name: "Streamlined eco-centric task-force",
							dateStart: "2020-09-02T14:00:00.000Z",
							dateEnd: "2020-09-02T15:00:00.000Z",
							presenters: [
								"Zita Kelsall",
								"Sande Denial"
							],
							credits: {
								Oceanic: "5"
							}
						},
						{
							id: 4,
							name: "Mandatory multi-tasking standardization",
							dateStart: "2020-09-02T15:30:00.000Z",
							dateEnd: "2020-09-02T16:30:00.000Z",
							presenters: [
								"Dirk Petrozzi",
								"Helaina Pittaway",
							],
							credits: {
								Fancy: "2"
							}
						}
					],
				},
				{
					id: 3,
					name: "Parallelism",
					dateStart: "2020-09-02T08:00:00.000Z",
					dateEnd: "2020-09-02T12:00:00.000Z",
					presentations: [
						{
							id: 5,
							name: "Distributed bottom-line monitoring",
							dateStart: "2020-09-02T09:00:00.000Z",
							dateEnd: "2020-09-02T10:00:00.000Z",
							presenters: [
								"Pascal Sherland",
							],
							credits: {
								YSK: "3"
							}
						}
					],
				}
			]
		}, {
			id: 2,
			date: "2020-09-23T12:00:00.000Z",
			sessions: []
		},
		{
			id: 3,
			date: "2020-09-24T12:00:00.000Z",
			sessions: []
		},
	],
	id: 1,
	globalPresenters: [
		"Sully Pittel",
		"Tiffanie Skough",
		"Freddy Schinetti",
		"Aluino Dyde",
		"Essa Panter",
		"Etan Yeardley",
		"Engelbert Eede",
		"Pascal Sherland",
		"Dirk Petrozzi",
		"Helaina Pittaway",
		"Zita Kelsall",
		"Sande Denial"
	],
	nextSessionId: 4,
	nextPresenterId: 13,
	nextPresentationId: 6,
	selectedSessionId: 0,
}

export default injection